import { render } from "./Login.vue?vue&type=template&id=3f40541a"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=3f40541a&lang=css"

import exportComponent from "E:\\vue project\\urban_cosmetic_catalog\\Front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__